import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const MicrophoneAllowedIcon = ({
  className,
  color
}: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className || 'rf-h-6 rf-w-6'}
      viewBox='0 0 28.5 41.453'
    >
      <g transform='translate(-374.543 -230)'>
        <path
          d='M401.748,280.386h-1.3a1.3,1.3,0,0,0-1.3,1.3v3.887a10.375,10.375,0,0,1-10.387,10.364q-.507,0-1.013-.051a10.679,10.679,0,0,1-9.328-10.775v-3.425a1.3,1.3,0,0,0-1.3-1.3h-1.3a1.3,1.3,0,0,0-1.3,1.3v3.252c0,7.258,5.176,13.728,12.307,14.711v2.765h-4.534a1.3,1.3,0,0,0-1.3,1.3V305a1.3,1.3,0,0,0,1.3,1.3H395.27a1.3,1.3,0,0,0,1.3-1.3v-1.3a1.3,1.3,0,0,0-1.3-1.3h-4.534v-2.735a14.264,14.264,0,0,0,12.307-14.107v-3.887A1.3,1.3,0,0,0,401.748,280.386Z'
          transform='translate(0 -34.842)'
          fill='#fff'
        />
        <path
          d='M406.719,248.348a2.769,2.769,0,0,1-1.969-.815l-5.251-5.25a2.786,2.786,0,0,1,0-3.938l1.145-1.148a2.786,2.786,0,0,1,3.941,0l2.138,2.139,3.98-3.981a7.773,7.773,0,0,0-15.16,2.416v12.955a7.773,7.773,0,0,0,15.546,0v-5.591l-2.393,2.393A2.767,2.767,0,0,1,406.719,248.348Z'
          transform='translate(-14.519)'
          fill={color || '#FFF'}
        />
        <path
          d='M428.061,245.381l-1.142-1.145h0a.808.808,0,0,0-1.142,0l-3.211,3.212-4.365,4.366-3.537-3.539h0a.808.808,0,0,0-1.142,0l-1.142,1.146h0a.808.808,0,0,0,0,1.142l5.251,5.251h0a.808.808,0,0,0,1.142,0l3.794-3.794,5.5-5.5h0A.808.808,0,0,0,428.061,245.381Z'
          transform='translate(-25.999 -9.681)'
          fill={color || '#FFF'}
        />
      </g>
    </svg>
  )
}

export default MicrophoneAllowedIcon
